import { BookOpenIcon, ChartBarSquareIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import styles from './styles/BottomNavBar.module.css';
import classNames from 'classnames';
import { memo } from 'react';

type Selection = "Diary" | "Dashboard" | "Explore";

interface SleepchartNavBarProps {
    selected?: Selection;
    onSelect: (view: Selection) => void;
}

const buttons = [
    { title: 'Diary', icon: BookOpenIcon },
    { title: 'Dashboard', icon: ChartBarSquareIcon },
    { title: 'Explore', icon: MagnifyingGlassIcon }
];

export const SleepchartNavBar = memo(function SleepchartNavBar({ selected, onSelect }: SleepchartNavBarProps) {
    return (
        <BottomNavBar
            buttons={buttons}
            selected={selected} 
            onSelect={(view) => onSelect(view as Selection)} 
        />
    );
});

interface BottomNavBarProps {
    buttons: { title: string; icon: typeof BookOpenIcon }[];
    selected?: string;
    onSelect: (view: string) => void;
}

function BottomNavBar({ selected, onSelect, buttons }: BottomNavBarProps) {
    const iconSize = "1.3rem";

    return (
        <nav className={styles.nav} aria-label="Main navigation">
            { buttons.map((button, i) =>
                <NavButton
                    key={i}
                    icon={
                        <button.icon
                            width={iconSize} 
                            strokeWidth={selected === button.title ? 2 : 1} 
                        />
                    }
                    title={button.title}
                    selected={selected === button.title}
                    onClick={() => onSelect(button.title)}
                />      
            )}
        </nav>
    );
}

interface NavButtonProps {
    icon: React.ReactNode;
    title: string;
    selected?: boolean;

    onClick: () => void;
}

function NavButton({ icon, title, selected, onClick }: NavButtonProps) {
    return (
        <button className={classNames(styles.buttonContainer, "btn")} aria-current={selected ? 'page' : undefined} onClick={() => onClick()}>
            <div className={styles.button}>
                <div className={classNames(styles['nav-icon'], { [styles['nav-icon-selected']]: selected })}>
                    {icon}
                </div>
                <span className={classNames(styles.title, { [styles.selectedTitle]: selected })}>{title}</span>
            </div>
        </button>
    );
}